import React, { useRef, useState, useEffect } from 'react'
import styles from './JYZNT.module.css'
import classNames from 'classnames'
import { message, Modal } from 'antd'
import HeaderBar from './HeaderBar.js'
import { useDispatch } from 'react-redux'
import CreateApp from './CreactApp/create.jsx'
import CreateZhishikuDialog from './createZhishikuDialog/index.jsx'
import ImagePage from './imgPage/index.jsx'
import TextPage from './textPage/index.jsx'
import TextPageOnline from './textPageOnline/index.jsx'

import { HTTP_URL } from '../../../util/constants.js'
import { getEduBotsListRequest, getSchoolBotListRequest } from './JYZNTApi'
import BotAndDatasetList from './BotAndDatasetList/BotAndDatasetList.js'
// import EduBotList from './EduBotItem/EduAllBotList.js'
import EduBotItem from './EduBotItem/EduBotItem.js'
import { clearAllCookies } from '../../../util/handleObject.js'
import Cookies from 'js-cookie'
import BotEntry from './BotOrDatasetsEntry/BotEntry.js'
import DatasetsEntry from './BotOrDatasetsEntry/DatasetsEntry.js'
import ShareBotModal from './ShareBotModal/ShareBotModal.js'
export default function JYZNT(props) {
  const dispatch = useDispatch()
  const [messageApi, contextHolder] = message.useMessage()
  const [isShowPage, setIsShowPage] = useState(props.autoOpenCreateApp)
  //控制文本类型的知识库上传
  const [isShowTextPage, setIsShowTextPage] = useState(false)
  //控制图片类型的知识库上传
  const [isShowImagePage, setIsShowImagePage] = useState(false)
  const [isShowTextPageOnline, setIsShowTextPageOnline] = useState(false)
  const [botAndDatasetsType, setBotAndDatasetsType] = useState(0)

  const [personAgentId, setPersonAgentId] = useState()
  const [showPublishButton, setShowPublishButton] = useState(false)
  const [eduBotList, setEduBotList] = useState([])
  const [schoolBotList, setSchoolBotList] = useState([])

  const [isShowCreateZhishikuDialog, setIsShowCreateZhishikuDialog] =
    useState(false)
  const [dataset_id, setDataset_id] = useState(props.id)
  const [shareBotVisible, setShareBotVisible] = useState(false)
  const [shareBotInfo, setShareBotInfo] = useState({})
  const botAndDatasetListRef = useRef(null)
  function getBotAndDatasetListFn() {
    if (botAndDatasetListRef.current) {
      botAndDatasetListRef.current.getBotListFn()
      botAndDatasetListRef.current.getDatasetListFn()
    }
  }

  const showCreateZhishikuDialog = () => {
    setIsShowCreateZhishikuDialog(true)
  }
  useEffect(() => {
    getBotFn()
    if (Cookies.get('type') == '3') {
      getSchoolBotFn()
    }
    // 在这里执行你的组件挂载后的逻辑
    // 这里可以返回一个清理函数，它会在组件卸载前执行
    return () => {}
  }, []) // 空数组意味着这个 effect 只会在组件挂载时执行一次

  const onChangeClose = (val, type) => {
    setIsShowPage(val)
    if (type == 'a') {
      setIsShowTextPage(true)
      setIsShowImagePage(false)
    } else if (type == 'b') {
      setIsShowImagePage(true)
      setIsShowTextPage(false)
    } else if (type == 'c') {
      setIsShowImagePage()
    }
    setBotAndDatasetsType(1)
    getBotAndDatasetListFn()
    getBotFn()
  }

  const getBotFn = () => {
    getEduBotsListRequest((data) => {
      if (data.ret == 1) {
        let botList = data.botInfo.DB_bot_list
        setEduBotList(botList)
      } else if (data.ret == 99) {
        messageApi.open({
          type: 'warning',
          // content: data.msg,
          content: data.msg,
        })
        setTimeout((e) => {
          sessionStorage.clear()
          clearAllCookies()
          window.location.reload()
        }, 1000)
      } else {
        message.warning(data.msg)
      }
    })
  }

  const getSchoolBotFn = () => {
    getSchoolBotListRequest((data) => {
      if (data.ret == 1) {
        setSchoolBotList(data.data)
      } else if (data.ret == 0) {
        setSchoolBotList([])
      }
    })
  }

  function onCreateClose() {
    setIsShowPage(false)
  }

  function createBotMethod(params) {
    //props.jumpToCreateBot(6)

    setIsShowPage(true)
    setPersonAgentId()
    setShowPublishButton(false)
  }

  function onCancelCreateZhishikuDialog() {
    setIsShowCreateZhishikuDialog(false)
    getBotAndDatasetListFn()
  }

  function onCancelImagePage() {
    setIsShowImagePage(false)
    getBotAndDatasetListFn()
  }

  function onCancelTextPage() {
    setIsShowTextPage(false)
    getBotAndDatasetListFn()
  }

  function onCancelTextPageOnline() {
    setIsShowTextPageOnline(false)
    getBotAndDatasetListFn()
  }

  function onSuccessImport() {}

  function onSuccessCreateZhishiku(format_type, importType, dataset_id) {
    setIsShowCreateZhishikuDialog(false)
    //message.success("知识库创建成功", 2);
    // 此处应该刷新知识库
    // getZSKListFn(ZSKType, ZSKCurrentPage, ZSKPageSize)

    setDataset_id(dataset_id)

    if (format_type == '0') {
      //文本类型
      if (importType == '0') {
        //本地文档
        setIsShowTextPage(true)
      } else if (importType == '1') {
        //在线文档
        setIsShowTextPageOnline(true)
      }
    } else if (format_type == '2') {
      //图片类型
      setIsShowImagePage(true)
    }
  }
  const clickBotItem = (item) => {
    window.open(
      HTTP_URL +
        `gongju/preview/index.html?botId=${item.bot_id}&icon=${btoa(item.icon_url)}&title=${item.bot_name}&userToken=${Cookies.get('userToken')}`,
    )
  }
  function editMethod(item) {
    setIsShowPage(true)
    setPersonAgentId(item.bot_id)
    if (item.status == 2) {
      setShowPublishButton(false)
    } else {
      setShowPublishButton(true)
    }
  }
  function changeShowAllBotMethod(value) {
    getBotFn()
    if (Cookies.get('type') == '3') {
      getSchoolBotFn()
    }
    setBotAndDatasetsType(0)
  }
  return (
    <div className={styles.background} style={{ paddingBottom: 30 }}>
      {botAndDatasetsType == 0 ? (
        <div>
          <HeaderBar
            createBot={createBotMethod}
            confirmSearch={(value) => {
              props.globalSearch(value, 3)
            }}
          />
          <div className={styles.botOrDatasetsEntry}>
            <BotEntry
              goToMethod={() => {
                setBotAndDatasetsType(1)
              }}
            />
            <DatasetsEntry
              goToMethod={() => {
                setBotAndDatasetsType(2)
              }}
            />
          </div>
          {Cookies.get('type') == '3' ? (
            <div>
              <div className={styles.tagTitle}>学校智能体空间</div>
              <div className={styles.eduBotListBox}>
                {schoolBotList.length > 0 ? (
                  schoolBotList.map((item, index) => (
                    <EduBotItem
                      key={index}
                      info={item}
                      index={index}
                      clickBotItem={clickBotItem}
                      shareBotItem={(item) => {
                        setShareBotInfo(item)
                        setShareBotVisible(true)
                      }}
                    />
                  ))
                ) : (
                  <div style={{ margin: '20px 0 20px 64px', fontSize: 18, color: '#999' }}>暂无学校智能体数据</div>
                )}
              </div>
            </div>
          ) : null}
          <div className={styles.tagTitle}>教育智能体广场</div>
          <div className={styles.eduBotListBox}>
            {eduBotList.map((item, index) => (
              <EduBotItem
                key={index}
                info={item}
                index={index}
                clickBotItem={clickBotItem}
                shareBotItem={(item) => {
                  console.log(item)
                  setShareBotInfo(item)
                  setShareBotVisible(true)
                }}
              />
            ))}
          </div>
        </div>
      ) : null}
      {botAndDatasetsType != 0 ? (
        <BotAndDatasetList
          type={botAndDatasetsType}
          clickBotItem={clickBotItem}
          backMethod={changeShowAllBotMethod}
          editMethod={editMethod}
          ref={botAndDatasetListRef}
          changeType={(value) => {
            setBotAndDatasetsType(value)
          }}
          getEduBotList={getBotFn}
          shareBotItem={(item) => {
            setShareBotInfo(item)
            setShareBotVisible(true)
          }}
          createBotMethod={createBotMethod}
          createDatasetMethod={showCreateZhishikuDialog}
        />
      ) : null}

      {isShowPage ? (
        <main className={styles.app}>
          <CreateApp
            bot_id={personAgentId}
            showPublishButton={showPublishButton}
            onChange={onChangeClose}
            onCreateClose={onCreateClose}
            showCreateZhishikuDialog={showCreateZhishikuDialog}
          />
        </main>
      ) : null}

      {isShowCreateZhishikuDialog ? (
        <CreateZhishikuDialog
          space_id={Cookies.get('coze_space_id')}
          bot_id=""
          onCancelCreate={onCancelCreateZhishikuDialog}
          onSuccess={onSuccessCreateZhishiku}
          onSuccessImport={onSuccessImport}
        />
      ) : null}

      {isShowImagePage ? (
        <ImagePage
          id={dataset_id}
          onChange={onChangeClose}
          onCancelImgPage={onCancelImagePage}
        /> //id为知识库的id
      ) : null}

      {isShowTextPage ? (
        <TextPage
          id={dataset_id}
          onChange={onChangeClose}
          onCancelTextPage={onCancelTextPage}
        />
      ) : null}

      {isShowTextPageOnline ? (
        <TextPageOnline
          id={dataset_id}
          onChange={onChangeClose}
          onCancelTextPage={onCancelTextPageOnline}
        />
      ) : null}
      <ShareBotModal
        info={shareBotInfo}
        visible={shareBotVisible}
        setVisible={(e) => {
          setShareBotVisible(e)
        }}
      />
    </div>
  )
}
